import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import http from "@/api/http";
import { getAuthStorage } from '@/api/service-localstorage';
var VUE_APP_EC_API = process.env.VUE_APP_EC_API; // 充值

export function goToPay() {
  return _goToPay.apply(this, arguments);
} // 轮询订单是否已经支付

function _goToPay() {
  _goToPay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var version,
        _getAuthStorage,
        accesstoken,
        projectId,
        _yield$http$post,
        respone,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            version = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'standard';
            _getAuthStorage = getAuthStorage(), accesstoken = _getAuthStorage.accesstoken, projectId = _getAuthStorage.projectId;
            _context.prev = 2;
            _context.next = 5;
            return http.post(VUE_APP_EC_API + '/api/v1/vipcustomized/native', {
              accesstoken: accesstoken,
              companyid: projectId,
              version: version
            });

          case 5:
            _yield$http$post = _context.sent;
            respone = _yield$http$post.data;

            if (!respone.success) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", respone.data);

          case 9:
            _Message({
              showClose: true,
              message: '支付错误，请找客服',
              customClass: 'common-box'
            });

            return _context.abrupt("return", false);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);

            if (_context.t0.response) {
              _Message({
                showClose: true,
                message: _context.t0.response.data.error.errorText,
                customClass: 'common-box'
              });
            }

            return _context.abrupt("return", false);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13]]);
  }));
  return _goToPay.apply(this, arguments);
}

export function checkOrderStatus(_x, _x2) {
  return _checkOrderStatus.apply(this, arguments);
}

function _checkOrderStatus() {
  _checkOrderStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(oid, version) {
    var _getAuthStorage2, accesstoken, projectId, _yield$http$post2, respone, data, orderInfo, validTime;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getAuthStorage2 = getAuthStorage(), accesstoken = _getAuthStorage2.accesstoken, projectId = _getAuthStorage2.projectId;
            _context2.prev = 1;
            _context2.next = 4;
            return http.post(VUE_APP_EC_API + '/api/v1/vipcustomized/getorderinfo', {
              accesstoken: accesstoken,
              companyid: projectId,
              version: version,
              outTradeNo: oid
            });

          case 4:
            _yield$http$post2 = _context2.sent;
            respone = _yield$http$post2.data;

            if (!respone.success) {
              _context2.next = 12;
              break;
            }

            data = respone.data;
            orderInfo = data.orderInfo, validTime = data.validTime;

            if (!orderInfo) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", validTime);

          case 11:
            return _context2.abrupt("return", false);

          case 12:
            return _context2.abrupt("return", false);

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", false);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 15]]);
  }));
  return _checkOrderStatus.apply(this, arguments);
}